var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMastercardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 19,
    viewBox: "0 0 30 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mastercard"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Left",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9053 16.4396C13.3266 17.7704 11.2787 18.5737 9.04092 18.5737C4.04776 18.5737 0 14.5741 0 9.64036C0 4.70662 4.04776 0.707031 9.04092 0.707031C11.2787 0.707031 13.3266 1.51036 14.9053 2.84109C16.484 1.51036 18.5319 0.707031 20.7697 0.707031C25.7628 0.707031 29.8106 4.70662 29.8106 9.64036C29.8106 14.5741 25.7628 18.5737 20.7697 18.5737C18.5319 18.5737 16.484 17.7704 14.9053 16.4396Z",
    fill: "#ED0006"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Right",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9053 16.4396C16.8492 14.8011 18.0818 12.363 18.0818 9.64036C18.0818 6.91776 16.8492 4.47962 14.9053 2.84108C16.484 1.51036 18.5319 0.707031 20.7697 0.707031C25.7628 0.707031 29.8106 4.70662 29.8106 9.64036C29.8106 14.5741 25.7628 18.5737 20.7697 18.5737C18.5319 18.5737 16.484 17.7704 14.9053 16.4396Z",
    fill: "#F9A000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Middle",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.905 16.4403C16.8489 14.8018 18.0815 12.3636 18.0815 9.64105C18.0815 6.91846 16.8489 4.48033 14.905 2.8418C12.9611 4.48033 11.7285 6.91846 11.7285 9.64105C11.7285 12.3636 12.9611 14.8018 14.905 16.4403Z",
    fill: "#FF5E00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercardIcon);
export default __webpack_public_path__ + "static/media/MastercardIcon.31a0cc2fecf21e5797b4c3af8a8209ad.svg";
export { ForwardRef as ReactComponent };